import React, { useState } from "react";

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// SharedLocationsGroup (#360) — collapses an Optimizer cell's "SHARED <loc>"
// entries into one expandable bar so real jobs read at a glance.
//
// Mervin: jobs get buried among repeated SHARED JAX / SHARED MAC rows. Option C:
// jobs render first, these shared entries fold into a single "Shared (N)" bar
// (placed ABOVE the attribute rows — OFF / BUFFER / custom — per Leland), and
// expand on click. Collapsed by default so a busy column scans instantly.
//
// The shared tiles are built by the caller (renderAssignedScheduledCells) as
// NON-clickable JobTiles; this component only groups + toggles them.
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

const SharedLocationsGroup = ({ tiles }) => {
  const [open, setOpen] = useState(false);
  const count = tiles?.length ?? 0;
  if (!count) return null;

  return (
    <div className="border-t border-skin-base/30 mt-0.5">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        title={open ? "Hide shared locations" : "Show shared locations"}
        className="text-sm-2 w-full flex items-center gap-1.5 px-1 pt-1 pb-0.5 text-skin-primary/80 font-bold uppercase tracking-wide hover:text-skin-primary"
      >
        <span
          className="inline-block transition-transform"
          style={{ transform: open ? "rotate(90deg)" : "none" }}
          aria-hidden="true"
        >
          ▸
        </span>
        Shared <span className="text-skin-primary">({count})</span>
      </button>
      {open ? <div className="flex flex-col gap-1 pb-0.5">{tiles}</div> : null}
    </div>
  );
};

export default SharedLocationsGroup;
